import { useMemo } from "react";
import { type RequestState, useAuthenticatedRequest } from "./request";

export interface LandingPageItem {
  teaserLabelColor: string;
  teaserLabelText: string;
  link: {
    text: string;
    url: string;
  };
  title: string;
  shortDescription: string;
  longDescription: string;
  carouselOrder: number;
  teaserImage: string;
}

export interface LandingPageResult {
  data: LandingPageItem[];
}

export function useLandingPage(
  language: string = "en",
): RequestState<LandingPageResult> {
  const config = useMemo(() => {
    const params = new URLSearchParams();
    params.set("language", language);
    return { params };
  }, [language]);

  return useAuthenticatedRequest<LandingPageResult>(
    "/v0/content/landing-page",
    config,
  );
}
